import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from "@angular/forms";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss']
})
export class TimeInputComponent implements OnInit, OnDestroy {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() control!: FormControl;

  hours: number = 0;
  minutes: number = 0;

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    if (this.control) {
      // Inicjalizacja wartości początkowej z kontrolki (np. z bazy)
      this.updateLocalValues(this.control.value);

      // Nasłuchiwanie zmian z zewnątrz (np. patchValue / reset)
      this.control.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => {
          this.updateLocalValues(value);
        });
    }
  }

  private updateLocalValues(totalMinutes: number): void {
    if (totalMinutes != null && !isNaN(totalMinutes)) {
      this.hours = Math.floor(totalMinutes / 60);
      this.minutes = Math.floor(totalMinutes % 60);
    } else {
      this.hours = 0;
      this.minutes = 0;
    }
  }

  onInputChange(): void {
    const h = Math.max(0, this.hours || 0);
    const m = Math.max(0, this.minutes || 0);
    const totalMinutes = h * 60 + m;

    if (this.control) {
      // Aktualizujemy kontrolkę łączną liczbą minut bez wywoływania zapętlono eventów
      this.control.setValue(totalMinutes, { emitEvent: false });
      this.control.markAsTouched();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
